import { PageController } from '@client/components/_core/layout/PageController';
import { StringListSetting } from '@client/components/_core/settings/StringListSetting';
import { supplierCategoriesSetting } from '@shared/schemas/org-settings';
import { createFileRoute } from '@tanstack/react-router';
import { Tags } from 'lucide-react';
import { SuppliersTabs } from './SuppliersTabs';

export const Route = createFileRoute('/console/$orgId/configuration/vendor-management/suppliers/definitions')({
    staticData: {
        metadata: {
            title: 'Supplier definitions',
        },
        ui: {
            title: 'Suppliers configuration',
        },
    },
    component: RouteComponent,
});

function RouteComponent() {
    return (
        <PageController route={Route}>
            <SuppliersTabs active="definitions" />
            <div className="grid grid-cols-1 items-start gap-4 lg:grid-cols-2">
                <StringListSetting
                    definition={supplierCategoriesSetting}
                    icon={Tags}
                    title="Supplier categories"
                    noun="category"
                    nounPlural="categories"
                    description="The categories a supplier can be filed under."
                />
            </div>
        </PageController>
    );
}
